/* eslint-disable react/jsx-curly-newline */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { Fragment } from 'react';
import { Grid } from 'semantic-ui-react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import { FormSelectField } from '../../../../semantic-ui/components/form-select-field';
import './styles.less';
import { ErrorComponent } from '../../../../components/error-component';

export const CompatibilityComponent = ({ fields, modes, isModesLoading }) => {
	return fields.map((name, index) => {
		return (
			<Fragment key={`${name}.compatibility`}>
				<Grid.Row className="order-group-form__row">
					<Grid.Column width={6} className="order-group-form__column">
						Совместимость #{index + 1}
					</Grid.Column>
					<Grid.Column width={8} className="order-group-form__column">
						<div className="order-group-form__compatibility-fields">
							<div className="order-group-form__compatibility-fields-wrapper">
								<div className="order-group-form__field">
									<Field
										name={`${name}.mode_id`}
										component={FormSelectField}
										placeholder="Т-режим"
										search
										options={modes}
										loading={isModesLoading}
										disabled={isModesLoading}
										noResultsMessage="Т-режим не найден"
										isWithoutSelectOnBlur
										isWithoutErrorText
									/>
								</div>
								<span className="order-group-form__compatibility-fields-separator">-</span>
								<div className="order-group-form__field">
									<Field
										name={`${name}.compatibility`}
										component={FormSelectField}
										placeholder="Совместимые т-режимы"
										search
										multiple
										options={modes}
										loading={isModesLoading}
										disabled={isModesLoading}
										noResultsMessage="Т-режим не найден"
										isWithoutSelectOnBlur
										isWithoutErrorText
									/>
								</div>
							</div>
						</div>
					</Grid.Column>
					{index === fields.length - 1 && (
						<Grid.Column width={2} className="order-group-form__centered_column">
							<div
								className="order-group-form__column_close"
								role="button"
								style={{ right: 80, top: 2 }}
								aria-label="Удалить группу"
								tabIndex="0"
								onClick={() => {
									fields.remove(index);
								}}
							/>
						</Grid.Column>
					)}
					<Grid.Column width={6} className="order-group-form__column__error" />
					<Grid.Column width={8} className="order-group-form__column__error">
						<div className="order-group-form__compatibility-fields">
							<div className="order-group-form__compatibility-fields-wrapper">
								<div className="order-group-form__field">
									<Field name={`${name}.mode_id`} component={ErrorComponent} />
								</div>
								<span className="order-group-form__compatibility-fields-separator" />
								<div className="order-group-form__field">
									<Field name={`${name}.compatibility`} component={ErrorComponent} />
								</div>
							</div>
						</div>
					</Grid.Column>
				</Grid.Row>
			</Fragment>
		);
	});
};

CompatibilityComponent.propTypes = {
	fields: PropTypes.object.isRequired,
	modes: PropTypes.array.isRequired,
	isModesLoading: PropTypes.bool,
};
